import { render, staticRenderFns } from "./BadReceipt.vue?vue&type=template&id=853c3a9c&"
import script from "./BadReceipt.vue?vue&type=script&lang=js&"
export * from "./BadReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports